<template>
  <div class="case-module" @click="toggleListActive(-1, 'body')">
    <div class="banner">
      <div class="swiper-pagination"></div>
      <swiper :options="swiperOptions">
        <template v-if="$store.state.sceneClassName === 'app'">
          <swiper-slide
            v-for="(item, index) in bannersApp"
            :key="`cmb_${index}`"
          >
            <img :src="item" alt="" />
          </swiper-slide>
        </template>
        <template v-else>
          <swiper-slide
            v-for="(item, index) in banners"
            :key="`cmb_${index}`"
            :style="{ backgroundImage: `url(${item})` }"
          ></swiper-slide>
        </template>
      </swiper>
    </div>
    <div class="w1200 cases-wrapper">
      <div class="clientcase-content">
        <el-radio-group class="clientcase-tab" v-model="clientcaseTab">
          <el-radio-button
            v-for="(item, index) in caseTabArr"
            :key="`ct_${index}`"
            :label="item"
            class="clientcase-tab-item"
          ></el-radio-button>
        </el-radio-group>
        <p v-if="$store.state.sceneClassName !== 'app'" class="tips">
          （ *以下排名不分先后顺序 ）
        </p>
        <div class="clientcase-box">
          <div
            v-for="item in 13"
            :key="`ce_${item}`"
            :class="
              $store.state.sceneClassName === 'app'
                ? `caseItem ${listActive === item ? 'active' : ''}`
                : 'caseItem caseItem1'
            "
          >
            <img :src="require('@/assets/images/case7.jpg')" alt="" />
            <h3 class="title">十点课堂</h3>
            <p class="desc">
              十点课堂是「十点读书」旗下的知识付费第一品牌，内容涵盖人文社科、生活美学、职场成长、女性变美等领域，打造多门爆款课程，全方位开放课程合作。
            </p>
            <div v-if="$store.state.sceneClassName === 'app'" class="see-btn">
              <span @click.stop="toggleListActive(item, 'item')">查看店铺</span>
            </div>
            <div class="caseQrcode">
              <img :src="require('@/assets/images/case6.png')" alt="" />
              <span>扫码查看</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="$store.state.sceneClassName !== 'app'"
        class="clientcase-example"
        style="margin-top: 0px; right: 193px"
      >
        <div class="clientcase-contact">
          <div class="contact-content">
            <img :src="require('@/assets/images/case8.png')" />
            <div class="contact-text">
              <p class="contact-title">免费领取行业资料</p>
              <p class="contact-desc">
                联系客户经理，领取你所在行业的定制解决方案
              </p>
            </div>
          </div>
          <a class="advisory-btn" id="qiyuEntry">咨询获取</a>
          <a class="register-btn" href="/" target="_blank">注册体验</a>
        </div>
        <div class="example-list">
          <div class="example-title">精选案例剖析</div>
          <div v-for="item in 10" :key="`ce_${item}`" class="example-item">
            <img
              :src="require('@/assets/images/case9.jpg')"
              class="example-item-img"
            />
            <a class="example-item-title" href="/"
              >大司马商学院：线下培训结构如何借助知链转型线上，15天营收破千万！</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Pagination, Autoplay } from 'swiper';
SwiperCore.use([Pagination, Autoplay]);
const caseTabArr = ['全部', '读书文化', '财经楼市', '养生塑形', '情感心理', '教培机构', '职场技能', 'IT科技', '管理咨询', '旅游行业', '金融机构', '法律行业', '出版传媒', '快消零售', '高等教育', '公益组织'];
const banners = [
  require('@/assets/images/case1.png'),
  require('@/assets/images/case2.jpg'),
  require('@/assets/images/case3.jpg'),
  require('@/assets/images/case4.png'),
  require('@/assets/images/case5.png')
];
const bannersApp = [
  require('@/assets/images/case1_app.png'),
  require('@/assets/images/case1_app.png'),
  require('@/assets/images/case1_app.png'),
  require('@/assets/images/case1_app.png'),
  require('@/assets/images/case1_app.png')
];
export default {
  data() {
    return {
      caseTabArr,
      clientcaseTab: '全部',
      banners,
      bannersApp,
      listActive: -1,
      swiperOptions: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 1500,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    };
  },
  methods: {
    toggleListActive(index) {
      this.listActive = index;
    }
  }
};
</script>

<style lang="scss">
.case-module {
  .banner {
    position: relative;
  }
  .banner {
    padding-top: 70px;
  }
  .swiper-pagination-bullets {
    width: 100%;
    bottom: 40px;
  }
  .swiper-pagination-bullet {
    width: 80px;
    height: 4px;
    background: #fff;
    opacity: 0.5;
    border-radius: 2px;
    margin: 0 5px;
  }
  .swiper-pagination-bullet-active {
    opacity: 1;
  }
  .swiper-container .swiper-slide {
    height: 480px;
    background-position: center center;
    background-repeat: no-repeat;
  }
  .user-box {
    background-color: #f5f6f9;
    padding: 80px 0;
  }
  .user-box .user {
    position: relative;
  }
  .user-box .user .online-corporate-title {
    font-size: 32px;
    font-weight: 500;
    color: #353535;
    line-height: 45px;
    text-align: center;
    margin-bottom: 56px;
  }
  .user-box .user .swiper-button-next,
  .user-box .user .swiper-button-prev {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-top: -10px;
    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    background-image: none;
    text-align: center;
    line-height: 70px;
    background: rgba(255, 255, 255, 0.5);
  }
  .user-box .user .swiper-button-next .iconfont,
  .user-box .user .swiper-button-prev .iconfont {
    font-size: 24px;
    color: #999;
  }
  .user-box .user .swiper-button-next {
    right: 0;
  }
  .user-box .user .swiper-button-prev {
    left: 0;
  }
  .swiper-container1 {
    overflow: hidden;
    width: 1050px;
    margin: 0 auto;
  }
  .swiper-container1 .swiper-slide {
    width: 246px;
    height: 361px;
    background: #fff;
    -webkit-box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.02),
      0 20px 40px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.02),
      0 20px 40px 0 rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    text-align: center;
    margin-bottom: 50px;
  }
  .swiper-container1 .swiper-slide .client-title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
    line-height: 25px;
    padding-bottom: 7px;
  }
  .swiper-container1 .swiper-slide .classify {
    padding: 0 8px;
    display: inline-block;
    height: 24px;
    line-height: 22px;
    border-radius: 2px;
    margin: 0 auto 24px;
    border: 1px solid #eee;
    font-size: 12px;
    font-weight: 400;
    color: #999;
  }
  .swiper-container1 .swiper-slide .text {
    font-size: 14px;
    color: #666;
    line-height: 20px;
    padding: 0 28px;
    margin-bottom: 16px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    display: -webkit-box;
  }
  .swiper-container1 .swiper-slide .link {
    display: inline-block;
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #666;
    font-size: 14px;
    color: #666;
  }
  .swiper-container1 .swiper-slide .link:hover {
    border-color: #1472ff;
    color: #1472ff;
  }
  .swiper-container1 .swiper-slide .img {
    margin-top: 24px;
  }
  .swiper-container1 .swiper-slide .img img {
    width: 120px;
    height: 120px;
    background: #fff;
    border: 1px solid #f5f6f9;
    border-radius: 50%;
  }
  .cases-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 96px 0;
  }
  .clientcase-content {
    width: 868px;
    height: auto;
  }
  .clientcase-content .tips {
    margin: 16px 0;
    font-size: 14px;
    color: #999;
  }
  .clientcase-tab {
    width: 868px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .clientcase-tab .clientcase-tab-item {
    cursor: pointer;
    display: inline-block;
    margin-right: 15px;
    margin-bottom: 16px;
    width: 95px;
    line-height: 36px;
    border: 1px solid #666;
    text-align: center;
    height: 36px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 36px;
    .el-radio-button__inner {
      padding: 0;
      background-color: transparent;
      border: 0;
      box-shadow: none;
    }
  }
  .clientcase-tab .clientcase-tab-item.is-active {
    background: #1472ff;
    color: #fff;
    border-color: #1472ff;
  }
  .clientcase-tab .clientcase-tab-item:nth-child(8n) {
    margin-right: 0;
  }
  .clientcase-box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: left;
    -ms-flex-pack: left;
    justify-content: left;
  }
  .clientcase-box .caseItem {
    width: 268px;
    height: 380px;
    padding: 32px 16px 40px;
    -webkit-box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
    margin: 0 1% 32px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    position: relative;
    -webkit-transition-property: -webkit-box-shadow;
    transition-property: -webkit-box-shadow;
    transition-property: box-shadow;
    transition-property: box-shadow, -webkit-box-shadow;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    cursor: pointer;
  }
  .clientcase-box .caseItem .case-img {
    display: block;
    width: 132px;
    height: 132px;
    border: 1px solid #f5f6f9;
    border-radius: 50%;
    margin: 0 auto 16px;
  }
  .clientcase-box .caseItem > img {
    display: block;
    width: 132px;
    height: 132px;
    background: #fff;
    border: 1px solid #f5f6f9;
    border-radius: 50%;
    margin: 0 auto 16px;
  }
  .clientcase-box .caseItem .title {
    font-size: 16px;
    color: #333;
    margin-bottom: 16px;
  }
  .clientcase-box .caseItem .desc {
    color: #333;
    font-size: 14px;
    line-height: 24px;
    height: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    text-align: justify;
  }
  .clientcase-box .caseItem .shop-link {
    display: inline-block;
    width: 200px;
    height: 44px;
    line-height: 44px;
    border: 1px solid #999;
    font-size: 14px;
    color: #666;
  }
  .clientcase-box .caseItem .caseQrcode {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    display: none;
    background: rgba(255, 255, 255, 0.9);
    top: 0;
    left: 0;
    z-index: 2;
  }
  .clientcase-box .caseItem .caseQrcode img {
    margin: 110px auto 18px;
    width: 120px;
    height: 120px;
    display: block;
  }
  .clientcase-box .caseItem .caseQrcode > span {
    font-size: 14px;
    color: #333;
  }
  .clientcase-box .caseItem1:hover .caseQrcode {
    display: block;
  }
  .more-case {
    width: 100px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    margin: 30px auto 100px;
    color: #2a75ed;
    cursor: pointer;
  }
  .more-case .icon-down {
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  .more-case.active .icon-down {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  .clientcase-example {
    width: 268px;
  }
  .clientcase-example .clientcase-contact {
    padding: 0 24px 24px;
    width: 100%;
  }
  .clientcase-example .contact-content {
    margin-bottom: 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .clientcase-example .contact-content img {
    margin-right: 8px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 59px;
    height: 62px;
  }
  .clientcase-example .contact-content .contact-title {
    color: #333;
    line-height: 26px;
    font-size: 18px;
  }
  .clientcase-example .contact-content .contact-desc {
    font-size: 12px;
  }
  .clientcase-example .advisory-btn,
  .clientcase-example .register-btn {
    display: inline-block;
    width: 204px;
    height: 28px;
    line-height: 28px;
    border: 1px solid transparent;
    border-radius: 16px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
  }
  .clientcase-example .advisory-btn {
    margin-bottom: 16px;
    background-color: #1472ff;
    color: #fff;
  }
  .clientcase-example .advisory-btn:hover {
    background: #3d91ff;
    border: 1px solid #3d91ff !important;
    color: #fff !important;
  }
  .clientcase-example .register-btn {
    color: #1472ff;
    border-color: #1472ff;
  }
  .clientcase-example .register-btn:hover {
    background: #3d91ff;
    border: 1px solid #3d91ff !important;
    color: #fff !important;
  }
  .clientcase-example .example-list {
    margin-top: 40px;
    width: 268px;
  }
  .clientcase-example .example-list .example-title {
    margin-bottom: 20px;
    font-size: 20px;
  }
  .clientcase-example .example-list .example-title::before {
    content: '';
    position: relative;
    top: 4px;
    margin-right: 8px;
    display: inline-block;
    width: 4px;
    height: 22px;
    background-color: #1472ff;
    border-radius: 2px;
  }
  .clientcase-example .example-list .example-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 16px;
  }
  .clientcase-example .example-list .example-item .example-item-img {
    margin-right: 16px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 53px;
    height: 40px;
    border-radius: 4px;
  }
  .clientcase-example .example-list .example-item .example-item-title {
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .clientcase-example .example-follow {
    margin-top: 17100px;
  }
  .example-fixed {
    position: fixed;
    top: 40px;
  }
}
.app .case-module {
  .banner {
    padding-top: 1.04rem;
    .swiper-pagination-bullets {
      bottom: 10px;
    }
    .swiper-pagination-bullet {
      width: 0.6rem;
      height: 0.04rem;
      border-radius: 0.02rem;
    }
    .swiper-container .swiper-slide {
      height: auto;

      img {
        height: auto;
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }
  .cases-wrapper {
    padding: 0 0.18rem;
    margin-top: 0.8rem;
    margin-bottom: 0.16rem;
    display: block;
    .clientcase-content,
    .clientcase-tab {
      width: auto;
    }
    .clientcase-tab .clientcase-tab-item {
      margin: 0 0.16rem 0.32rem;
      width: 2.06rem;
      height: 0.7rem;
      line-height: 0.7rem;
      border-width: 0.02rem;
      border-radius: 0.36rem;
      font-size: 0.28rem;
    }
  }
  .clientcase-box {
    padding-top: 0.16rem;
    display: block;
    .caseItem {
      width: 100%;
      height: 2.88rem;
      padding: 0.32rem 0.32rem 0.32rem 2.24rem;
      margin-bottom: 0.32rem;
      margin-left: 0;
      box-shadow: 0 0.16rem 0.48rem 0 rgba(0, 0, 0, 0.08);
      box-sizing: border-box;
      text-align: center;
      border-radius: 0.16rem;
      position: relative;
      transition-property: box-shadow;
      transition-duration: 0.3s;
      & > img {
        position: absolute;
        left: 0.32rem;
        top: 0.32rem;
        width: 1.6rem;
        height: 1.6rem;
        background: #fff;
        border: 0.02rem solid #eee;
        border-radius: 50%;
      }
      h3 {
        text-align: left;
        font-size: 0.32rem;
        margin-bottom: 0.12rem;
        padding-top: 0.1rem;
      }
      .desc {
        font-size: 0.24rem;
        line-height: 0.36rem;
        height: 0.72rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .see-btn {
        margin-top: 0.26rem;
        text-align: right;
        a {
          display: inline-block;
          box-sizing: content-box;
          width: 1.28rem;
          height: 0.48rem;
          line-height: 0.52rem;
          border: 0.02rem solid #333;
          border-radius: 0.24rem;
          font-size: 0.24rem;
          text-align: center;
          color: #333;
        }
      }
      &.active {
        .caseQrcode {
          display: block;
          background: #ffffff;
        }
        img {
          width: 1.95rem;
          height: 1.95rem;
          margin: 0.2rem auto 0.1rem;
          display: block;
        }
        span {
          font-size: 0.22rem;
          color: #666;
        }
      }
    }
  }
}
</style>
